import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { CircularsFixedRebateOptions, Percentages } from 'src/app/shared/models/circular.model';
import { ErrorsEnum, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CircularService } from 'src/app/shared/services/circular.service';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-circulars-refund-close',
  templateUrl: './circulars-refund-close.component.html',
  styleUrls: []
})
export class CircularsRefundCloseComponent implements OnInit {
  //#region Properties & Variables
  private circularsRequestId: string = "";
  @ViewChild('circularsRequest',{static: false}) circularsRequest: CircularRequestComponent;
  public isRequestSucceeded: boolean = false;
  //Options
  public circularsRequestOptions: CircularsFixedRebateOptions[] = [];
  //Submit
  private ResponseObject: ResponseObject = new ResponseObject();
  private isFormSubmitted: boolean = false;
  private isRefundedNotValid: boolean = false;
  private isPassingDateNotValid: boolean = false;
  //Form Mode
  private formMode: FormMode = FormMode.New;
  public isFormValid: boolean = true;
  //User Properties
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  public Percentages: Percentages[] = [];
  public uniquePercentages = [];
  RefundedPercentageId: string = "";
  public IsRefundedAndClosed: boolean = false;
  //#endregion
  constructor(private circularsService: CircularService, public datepipe: DatePipe, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onCircularsRequestLoadedFlag(flag: boolean) {
    if (flag) {
      this.circularsRequestId = this.circularsRequest.rebateRequestLoaded.Id;
      this.circularsRequestOptions = this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions;
      this.RefundedPercentageId = (this.circularsRequest.rebateRequestLoaded.RefundedPercentageId !== undefined && this.circularsRequest.rebateRequestLoaded.RefundedPercentageId !== 0) ? this.circularsRequest.rebateRequestLoaded.RefundedPercentageId.toString() : "";
      this.circularsRequest.editModeAdmin = true;
      this.LoadPercentages();
      this.setFormMode();
      console.log(this.circularsRequest);
    }
  }
  LoadPercentages(): void {
    this.Percentages = [];
    this.circularsService.getPercentagesByCircularId(this.circularsRequest.rebateRequestLoaded.CircularsLookupId.toString()).subscribe(
      data => this.Percentages = data.Data as Percentages[],
      () => console.log("Something went wrong in getPercentagesByCircularId!!"),
      () => this.loadUniquePercentage()
    );
  }
  loadUniquePercentage() {
    for (var item, i = 0; item = this.Percentages[i++];) {
      var percentageId = item.Id;
      var percentageValue = item.PercentageValue;
      if (this.uniquePercentages.find(p => p.PercentageValue == percentageValue) == undefined) {
        this.uniquePercentages.push({
          Id: percentageId,
          PercentageValue: percentageValue
        });
      }
    }
  }
  OnRefundChange() {
    console.log(this.RefundedPercentageId)
    if (this.circularsRequest.rebateRequestLoaded.IsRefunded) {
      this.circularsRequest.rebateRequestLoaded.IsClosed = true;
      this.IsRefundedAndClosed = true;
    } else {
      this.circularsRequest.rebateRequestLoaded.IsClosed = false;
      this.IsRefundedAndClosed = false;
    }
  }
  OnRefundPercentageChange() {
    if (this.RefundedPercentageId !== "") {
      this.isRefundedNotValid = false;
    } else {
      this.isRefundedNotValid = true;
    }
  }
  submit(): void {
    //Check Form Validity
    if (this.circularsRequest.rebateRequestLoaded.IsRefunded || this.circularsRequest.rebateRequestLoaded.IsClosed) {
      this.circularsRequest.rebateRequestLoaded.RefundedPercentageId = parseInt(this.RefundedPercentageId);
      if (this.circularsRequest.rebateRequestLoaded.IsRefunded && this.RefundedPercentageId == "") {
        this.isRefundedNotValid = true;
        this.isFormValid = false;
      }
    } else {
      this.isFormValid = false;
    }
    if (this.isFormValid) {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.submitRefundClose();
    }
  }
  submitRefundClose(): void {
    this.circularsService.refundCloseRequest(this.circularsRequest.rebateRequestLoaded).subscribe(
      data => this.ResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitRefundCloseCompleted()
    );
  }
  submitRefundCloseCompleted(): void {
    if (!this.ResponseObject.Success) {
      //Enable Error / Warning
      if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }

  setFormMode(): void {
    if (this.circularsRequest.rebateRequestLoaded.IsRefunded || this.circularsRequest.rebateRequestLoaded.IsClosed || (this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_PendingRequestorApproval && this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_AcceptedByRequestor && this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_ShipPassed && this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_PendingRequestorApproval && this.circularsRequest.rebateRequestLoaded.ExternalStatusId != ServiceStatus.Circulars_AcceptedByRequestor && this.circularsRequest.rebateRequestLoaded.ExternalStatusId != ServiceStatus.Circulars_ShipPassed)) {
      this.formMode = FormMode.Details;
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }

}

enum FormMode {
  New = 1,
  Details = 2
}

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
